import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'
import { FundListService } from 'src/app/services/fund-list.service';

@Component({
  selector: 'app-fund-compare',
  templateUrl: './fund-compare.component.html',
  styleUrls: ['./fund-compare.component.scss']
})
export class FundCompareComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  fundList: Array<Object> = [];
  selectListDropdown = []
  fundId: number
  fundId2: number

  id1Req: boolean = false
  id2Req: boolean = false

  constructor(private router: Router, private _fundListService: FundListService) { }

  ngOnInit() {
    this._fundListService.getFundList().subscribe(response => {
      this.fundList = response["Result"]
      this.getFundCode(this.fundList)
    })
  }

  getFundCode(fundList: object) {
    Object.entries(fundList).forEach(
      ([key, value]) => {
        this.showFundCode(value)
      }
    );
  }

  showFundCode(fundCode) {
    this.selectListDropdown.push({ title: fundCode.FundCode, value: fundCode.FundId })
  }

  getFundIdFromSelect($event) {
    this.fundId = $event
  }

  getFundIdFromSelect2($event) {
    this.fundId2 = $event
  }

  gotoCompareResult() {
    if (this.fundId == undefined) {
      this.id1Req = true
    } else {
      this.id1Req = false
    }

    if (this.fundId2 == undefined) {
      this.id2Req = true
    } else {
      this.id2Req = false
    }

    if (this.id1Req == false && this.id2Req == false) {
      this.router.navigate(['/fund/compare/result', this.fundId, this.fundId2])
    }


  }

}
